//
const WARNING_TIMEOUT = 270; // seconds 270
const SESSION_TIMEOUT = 300; // seconds 300
const NAMESPACE = `pri.pc2.${window.appConfig.env}.`;

export class Session {
  interval: number | undefined;

  static get(key: string, isLocal?: boolean) {
    return this.getStorage(isLocal).getItem(`${NAMESPACE}${key}`);
  }

  static set(key: string, value: string, isLocal?: boolean) {
    this.getStorage(isLocal).setItem(`${NAMESPACE}${key}`, value);
  }

  static remove(key: string, isLocal: boolean) {
    this.getStorage(isLocal).removeItem(`${NAMESPACE}${key}`);
  }

  static clear(isLocal: boolean) {
    this.getStorage(isLocal).clear();
  }

  static getStorage(isLocal?: boolean) {
    return isLocal ? window.localStorage : window.sessionStorage;
  }

  static now() {
    return Math.floor(Date.now() / 1000);
  }

  static getLastActive() {
    return Number(this.get('last_active'));
  }

  static setLastActive(lastActive: number) {
    this.set('last_active', lastActive.toString());
  }

  static resetExpiration() {
    this.setLastActive(this.now());
  }

  static timer(continueCallback: () => boolean, expiredCallback: () => boolean) {
    return () => {
      const lastActive = this.getLastActive();
      if (this.now() - lastActive > SESSION_TIMEOUT) {
        expiredCallback();
        return false;
      }
      if (this.now() - lastActive > WARNING_TIMEOUT) {
        continueCallback();
        return false;
      }
      return true;
    };
  }
}
